// extracted by mini-css-extract-plugin
module.exports = {"container":"bannerCarousels__container___Chq9v"};